import { render, staticRenderFns } from "./BranchTimeAdd.vue?vue&type=template&id=6481984a&scoped=true&"
import script from "./BranchTimeAdd.vue?vue&type=script&lang=js&"
export * from "./BranchTimeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6481984a",
  null
  
)

export default component.exports